
Object.defineProperty(exports, '__esModule', {
	value: true
});

exports.default = {
	bind: function bind(el, binding) {
		const bubble = binding.modifiers.bubble;

		function handler(e) {
			if (bubble || (!el.contains(e.target) && el !== e.target)) {
				binding.value(e);
			}
		}

		el.vueClickOutside = handler;
		document.addEventListener('click', handler);
	},
	unbind: function unbind(el) {
		document.removeEventListener('click', el.vueClickOutside);
		el.vueClickOutside = null;
	}
};
